import exp from "constants";

const DemographicsCard = ({ selectedPatient, t }: any) => {

    const lang = localStorage.getItem("i18nextLng") === "en" ? "en-US" : "tr-TR";

    const registerDateTemplate = (rowData: any) => {
        const date = new Date(rowData.dateCreated)

        const options: any = { month: 'long', day: 'numeric', year: 'numeric' };
        return date.toLocaleDateString(lang, options);
    }

    return (
        <div className="flex flex-column justify-content-between flex-shrink-0 w-15rem"
            style={{
                borderRadius: "15px",
                background: "#FFFFFF",
                padding: "1.5rem",
                boxShadow: "0 4px 4px -1px rgba(45, 57, 103, 0.05), 0 4px 10px -1px rgba(45, 57, 103, 0.1)",
                overflowY: "auto",
            }}>
            <div className="flex flex-column gap-4">
                <p className="m-0 text-lg font-bold" style={{ color: "#2D3967" }}>{t('demographics')}</p>
                <div className="flex flex-column gap-2">
                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('genderWord')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}>{selectedPatient.gender}</p>
                    </div>
                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('age')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}> {selectedPatient.age ? selectedPatient.age : "---"}</p>
                    </div>
                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('weight')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}> {selectedPatient.weight ? selectedPatient.weight : "---"}</p>
                    </div>
                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('height')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}>{selectedPatient.height ? selectedPatient.height : "---"}</p>
                    </div>

                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('bodyIndex')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}>{selectedPatient.height && selectedPatient.weight ? selectedPatient.weight / (selectedPatient.heightselectedPatient.height) : "---"}</p>
                    </div>

                    <br />
                    <div style={{ height: "1px", border: "1px solid #EAEBF0" }}></div>
                    <br />

                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('phoneNumber')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}>{selectedPatient.phoneNumber ? selectedPatient.phoneNumber : "---"}</p>
                    </div>

                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('registerDate')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}>{registerDateTemplate(selectedPatient)}</p>
                    </div>

                    <div className="flex flex-column">
                        <p className="m-0 font-bold" style={{ color: "#2D3967", whiteSpace: "nowrap" }}> {t('registerCode')}</p>
                        <p className="m-0 text-sm" style={{ color: "#727A99", whiteSpace: "nowrap" }}>{selectedPatient.code ? selectedPatient.code : "---"}</p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default DemographicsCard;